/* eslint-disable */
export default {
  dial: 'ダイヤル',
  message: 'メッセージ',
  transfer: '転送',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
